export default __webpack_public_path__ + "static/media/hero.2c0445ca.svg";